import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-07/task-02";

const task: Slide = {
  titleHtml:
    "In a sports hall, the seats for the visitors are located on both sides of the court. The<br>sound system in the hall is distributed, i.e., both sides of the visitor area are divided<br>into sectors, and each sector is covered by a single loudspeaker. If, for any reason,<br>only one side of the visitor area is open, and the other one remains closed and<br>unoccupied, is it better to leave the entire sound system on, or to switch off the part<br>that covers the empty side of the visitor area?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
